import { CUSTOMER_CHANNELS } from '../constants';

import { User } from './@types';

export const checkIsTradeSeller = (user: Partial<User> | null) => user?.channel === CUSTOMER_CHANNELS.TRADE;
